const formatDateTimeUK = (timestamp) => {
	// timestamp can be 'YYYY-MM-DD' or 'YYYY-MM-DDTHH:MM:SS.000Z'

	const date = new Date(timestamp);

	const day = String(date.getDate()).padStart(2, '0');
	const month = String(date.getMonth() + 1).padStart(2, '0');
	const year = date.getFullYear();

	const hasTime = timestamp.includes('T');

	if (hasTime) {
		const hours = String(date.getHours()).padStart(2, '0');
		const minutes = String(date.getMinutes()).padStart(2, '0');
		return `${day}/${month}/${year} ${hours}:${minutes}`;
	} else {
		return `${day}/${month}/${year}`;
	}
};

export default formatDateTimeUK;
